module.exports = {
  PORT: process.env.PORT || 3000,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL ||
    'http://localhost:3001/api'
};



// WEBPACK FOOTER //
// ./src/config.js